import { RouterProvider } from "@tanstack/react-router"

import { useAuth } from "../hooks/use-auth"
import type { router } from "../router"

export function RouterProviderWithContext({ router: routerInstance }: { router: typeof router }) {
  const auth = useAuth()

  // Hold the router until /api/auth/me has resolved — otherwise route
  // guards see `auth.user === null` for the first paint and bounce
  // already-signed-in users to /login.
  if (auth.isLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center text-sm text-muted-foreground">
        Loading…
      </div>
    )
  }

  return <RouterProvider router={routerInstance} context={{ auth }} />
}
